<template></template>

<script>
import notyMixin from "@/helpers/noty";
import { liveCoachLeftNotification } from "./notifications";

export default {
  mixins: [notyMixin],
  props: ["channel"],
  created() {
    this.channel.bind("connection.closed", ({ participant }) => {
      if (participant.isGhost) {
        this.$_notificationsToCloseOnDestroy.push(
          liveCoachLeftNotification({ name: participant.name }).show()
        );
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// connection-closed.vue?0acb25ad